/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = MFGTransactionLossRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MFGTransactionLossEditor extends Common.GridEditorBase<MFGTransactionLossRow> {



        protected getColumnsKey() { return "Production.MFGTransactionLoss"; }
        protected getDialogType() { return MFGTransactionLossDialog; }
        protected getLocalTextPrefix() { return MFGTransactionLossRow.localTextPrefix; }
        protected form: MFGTransactionLossForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public DismantlingType: number;


        // #endregion


        constructor(container: JQuery) {
            super(container);
            //this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            //   this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: true });
        }

        private Master;
        public setEditValue(source: DismantlingRow, property) {
            super.setOwnerEntity(source);
            this.Master = source;
            super.setEditValue(source, property);
        }
        
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();


                if (target.hasClass('delete-row')) {

                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {
                        var id = this.id(item);
                        this.view.deleteItem(id);
                        this.element.trigger('dialogclose');

                    });

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            this.view.refresh();

        }
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }
        public setdata(item: MFGTransactionBOMRow, weight: number) {
            this.view.setItems([], false);
            var newloss: MFGTransactionLossRow = {
                AttributeId: item.AttributeId,
                Attribute: item.Attribute,
                CalcOnId: item.CalcOnId,
                BagNo: item.BagNo,
                BomProductId: item.BomProductId,
                ProductCode: item.ProductCode,
                ItemTypeId: item.ItemTypeId,
                FromDeptId: item.FromDeptId,
                Line_No: item.Line_No,
                Pieces: item.Pieces,
                ProductId: item.ProductId,
                PureWeight: item.PureWeight,
                Purity: item.Purity,
                RefTransBomId: item.RefTransBomId,
                RefTransId: item.RefTransId,
                RefTransItemId: item.RefTransItemId,
                RefVoucherId: item.RefVoucherId,
                Weight: weight,
            }
            newloss[this.getIdProperty()] = "`" + this.nextId++;
            this.view.addItem(newloss);
            
        }
        public setdatawithvalues(items: MFGTransactionLossRow[]) {
            this.view.setItems([], false);
            for (var a = 0; a < items.length; a++) {
                var item = items[a];
                var newloss: MFGTransactionLossRow = {
                    AttributeId: item.AttributeId,
                    Attribute: item.Attribute,
                    CalcOnId: item.CalcOnId,
                    BagNo: item.BagNo,
                    BomProductId: item.BomProductId,
                    ProductCode: item.ProductCode,
                    ItemTypeId: item.ItemTypeId,
                    FromDeptId: item.FromDeptId,
                    Line_No: item.Line_No,
                    Pieces: item.Pieces,
                    ProductId: item.ProductId,
                    PureWeight: item.PureWeight,
                    Purity: item.Purity,
                    RefTransBomId: item.RefTransBomId,
                    RefTransId: item.RefTransId,
                    RefTransItemId: item.RefTransItemId,
                    RefVoucherId: item.RefVoucherId,
                    Weight:item.Weight,
                }
                newloss[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(newloss);

            }
        }

        public cleardata() {

            this.view.setItems([], false);

        }


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons.pop();
            return [ Serenity.ColumnPickerDialog.createToolButton(this as any)]; 
        }

    }
}